<template>
  <el-dialog
    :title="title || '确认信息是否正确'"
    :visible.sync="localVisible"
    center
    destroy-on-close
    width="40%"
    custom-class="ful-dialog"
  >
    <ul class="ful-dialog-info" style="margin-top: 0px; width: 100%">
      <slot></slot>
    </ul>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="ful-dialog-btn-cancel"
        @click="onCancel"
        style="margin-right: 30px; border-radius: 20px; padding: 10px 28px; font-size: 15px;"
        >再看看</el-button
      >
      <el-button
        class="ful-dialog-btn-confirm"
        type="primary"
        @click="onConfirm"
        style="margin-left: 30px; border-radius: 20px; padding: 10px 28px; font-size: 15px;"
        >确认提交</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "确认信息是否正确",
    },
  },
  computed: {
    localVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    onCancel() {
      this.localVisible = false;
      this.$emit("cancel");
    },
    onConfirm() {
      this.$emit("confirm");
    },
  },
};
</script>

<style scoped>
.ful-dialog-btn-cancel {
  background-color: #ffffff;
  border-color: #009798;
  color: #009798;
}

.ful-dialog-btn-cancel:hover,
.ful-dialog-btn-cancel:focus {
  background-color: #eaf6f4;
  border-color: #009798;
  color: #009798;
}

.ful-dialog-btn-confirm {
  background-color: #009798;
  border-color: #009798;
  color: #ffffff;
}

.ful-dialog-btn-confirm:hover,
.ful-dialog-btn-confirm:focus {
  background-color: #007e7f;
  border-color: #007e7f;
}
</style>

